import { DocumentNode, gql } from '@apollo/client';
import * as React from 'react';

import { RespondButton } from '@/components/Post/components/RespondButton';
import { ThumbsUpIcon } from '@/imports/ui/chakra/feather';
import { DataPhTags } from '@/analytics';

import { CommentLikeButton_CommentFragment } from './graphql-types/CommentLikeButton_CommentFragment';

import { useCommentLike } from './hooks/useCommentLike';

export const CommentLikeButton: React.FC<{
  comment: CommentLikeButton_CommentFragment;
  onClickOverride?: () => void;
}> & {
  commentFragment: DocumentNode;
} = ({ comment, onClickOverride }) => {
  const { handleLikeClick, isLoading } = useCommentLike(comment);
  const isLiked = comment.currentUserReaction?.reactionType === 'LIKE';
  return (
    <RespondButton
      data-ph={DataPhTags.COMMENT_LIKE}
      onClick={onClickOverride ? onClickOverride : handleLikeClick}
      color={isLiked ? 'primary.500' : 'gray.600'}
      size="sm"
      isDisabled={isLoading}
      leftIcon={<ThumbsUpIcon isLiked={isLiked} />}
    >
      Like
    </RespondButton>
  );
};

CommentLikeButton.commentFragment = gql`
  fragment CommentLikeButton_CommentFragment on Comment {
    _id
    currentUserReaction {
      _id
      reactionType
    }
    ...useCommentLike_CommentFragment
  }
  ${useCommentLike.commentFragment}
`;
